/**
 * Kinetic Tech — theme interactions (vanilla JS, ES5 for gulp-uglify).
 *
 * - sticky header shadow
 * - mobile menu / search overlay toggles
 * - scroll to top
 * - article TOC generation + scrollspy
 * - copy-link share button
 * - tools directory live filter
 * - news grid/list view toggle
 * - AJAX "load more articles"
 */
(function () {
	'use strict';

	function ready(fn) {
		if (document.readyState !== 'loading') {
			fn();
		} else {
			document.addEventListener('DOMContentLoaded', fn);
		}
	}

	function on(el, event, fn) {
		if (el) {
			el.addEventListener(event, fn);
		}
	}

	ready(function () {

		/* ============ 1. Sticky header shadow ============ */
		var header = document.getElementById('kt-header');

		function headerShadow() {
			if (!header) return;
			if (window.pageYOffset > 4) {
				header.classList.add('is-scrolled');
			} else {
				header.classList.remove('is-scrolled');
			}
		}
		window.addEventListener('scroll', headerShadow, { passive: true });
		headerShadow();

		/* ============ 2. Mobile menu toggle ============ */
		var menuToggle = document.getElementById('kt-menu-toggle');
		var mobileMenu = document.getElementById('kt-mobile-menu');
		var menuFocus = null;

		function setMenu(open, returnFocus) {
			if (!header || !menuToggle) return;
			header.classList.toggle('is-menu-open', open);
			menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
			if (mobileMenu) {
				if (open) {
					mobileMenu.removeAttribute('hidden');
				} else {
					mobileMenu.setAttribute('hidden', '');
				}
			}
			var menuIcon = menuToggle.querySelector('.material-symbols-outlined');
			if (menuIcon) menuIcon.textContent = open ? 'close' : 'menu';
			document.body.classList.toggle('kt-menu-open', open);
			if (open && mobileMenu) {
				var firstLink = mobileMenu.querySelector('a');
				if (firstLink) firstLink.focus();
			}
			if (!open && returnFocus && menuFocus) menuFocus.focus();
		}

		on(menuToggle, 'click', function () {
			var open = !header.classList.contains('is-menu-open');
			menuFocus = document.activeElement;
			setSearch(false, false);
			setMenu(open, false);
			var searchToggle = document.getElementById('kt-search-toggle');
			if (searchToggle) searchToggle.setAttribute('aria-expanded', 'false');
		});

		/* ============ 2b. Header submenu toggles ============ */
		// Desktop: hover/focus reveals dropdowns via CSS. On coarse-pointer
		// (touch) devices the first tap toggles open, the second navigates.
		var navList = document.querySelector('.kt-nav__list');
		if (navList) {
			var coarsePointer = window.matchMedia('(hover: none)');
			var navParents = navList.querySelectorAll(':scope > .menu-item-has-children > a');

			function closeNavSubmenus() {
				Array.prototype.forEach.call(navList.querySelectorAll('.menu-item-has-children.is-open'), function (open) {
					open.classList.remove('is-open');
					var link = open.querySelector('a');
					if (link) link.setAttribute('aria-expanded', 'false');
				});
			}

			Array.prototype.forEach.call(navParents, function (link) {
				link.setAttribute('aria-expanded', 'false');
				link.addEventListener('click', function (e) {
					if (!coarsePointer.matches) return;
					var li = link.parentNode;
					if (!li.classList.contains('is-open')) {
						e.preventDefault();
						closeNavSubmenus();
						li.classList.add('is-open');
						link.setAttribute('aria-expanded', 'true');
					}
				});
			});

			document.addEventListener('click', function (e) {
				if (!navList.contains(e.target)) closeNavSubmenus();
			});
			document.addEventListener('keydown', function (e) {
				if (e.key === 'Escape') closeNavSubmenus();
			});
		}

		// Mobile panel: accordion sub-menus (tap parent to expand).
		var mobileList = document.querySelector('.kt-header__mobile-list');
		if (mobileList) {
			var mobileParents = mobileList.querySelectorAll('.menu-item-has-children > a');

			Array.prototype.forEach.call(mobileParents, function (link, index) {
				var submenu = link.parentNode.querySelector(':scope > .sub-menu');
				if (submenu) {
					var submenuId = submenu.id || 'kt-mobile-submenu-' + index;
					submenu.id = submenuId;
					link.setAttribute('aria-controls', submenuId);
				}
				link.setAttribute('aria-expanded', 'false');
				link.addEventListener('click', function (e) {
					var li = link.parentNode;
					var isOpen = li.classList.contains('is-open');

					Array.prototype.forEach.call(mobileList.querySelectorAll('.menu-item-has-children.is-open'), function (open) {
						if (open !== li) {
							open.classList.remove('is-open');
							open.querySelector('a').setAttribute('aria-expanded', 'false');
						}
					});

					if (isOpen) {
						e.preventDefault();
						li.classList.remove('is-open');
						link.setAttribute('aria-expanded', 'false');
					} else {
						e.preventDefault();
						li.classList.add('is-open');
						link.setAttribute('aria-expanded', 'true');
					}
				});
			});
		}

		/* ============ 3. Search overlay toggle ============ */
		var searchToggle = document.getElementById('kt-search-toggle');
		var searchPanel = document.getElementById('kt-header-search');
		var searchFocus = null;

		function setSearch(open, returnFocus) {
			if (!header || !searchToggle) return;
			header.classList.toggle('is-search-open', open);
			searchToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
			if (searchPanel) {
				if (open) {
					searchPanel.removeAttribute('hidden');
				} else {
					searchPanel.setAttribute('hidden', '');
				}
			}
			if (open) {
				var field = searchPanel ? searchPanel.querySelector('input[type="search"]') : null;
				if (field) field.focus();
			}
			if (!open && returnFocus && searchFocus) searchFocus.focus();
		}

		on(searchToggle, 'click', function () {
			var open = !header.classList.contains('is-search-open');
			searchFocus = document.activeElement;
			setMenu(false, false);
			setSearch(open, false);
		});

		document.addEventListener('keydown', function (e) {
			if (e.key !== 'Escape') return;
			if (header && header.classList.contains('is-menu-open')) setMenu(false, true);
			if (header && header.classList.contains('is-search-open')) setSearch(false, true);
		});

		window.addEventListener('resize', function () {
			if (window.innerWidth >= 992) {
				setMenu(false, false);
				setSearch(false, false);
			}
		});

		/* ============ 4. Scroll to top ============ */
		var scrollTopBtn = document.getElementById('kt-scroll-top');

		function scrollTopVisibility() {
			if (!scrollTopBtn) return;
			if (window.pageYOffset > 400) {
				scrollTopBtn.classList.add('is-visible');
			} else {
				scrollTopBtn.classList.remove('is-visible');
			}
		}
		window.addEventListener('scroll', scrollTopVisibility, { passive: true });
		scrollTopVisibility();
		on(scrollTopBtn, 'click', function () {
			var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
			window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
		});

		/* ============ 5. TOC generation + scrollspy (article + tool pages) ============ */
		function uniqueNodes(selector) {
			var nodes = document.querySelectorAll(selector);
			var arr = [];
			var seen = [];
			Array.prototype.forEach.call(nodes, function (n) {
				if (seen.indexOf(n) === -1) {
					seen.push(n);
					arr.push(n);
				}
			});
			return arr;
		}

		var contentEl = document.getElementById('kt-article-content') || document.getElementById('kt-tool-content');
		var tocNavs = uniqueNodes('.kt-toc, #kt-toc, #kt-toc-mobile');
		var tocWraps = uniqueNodes('.kt-toc-wrap, #kt-toc-wrap, .kt-toc-mobile, #kt-toc-mobile-wrap');

		if (contentEl && tocNavs.length) {
			var headings = contentEl.querySelectorAll('h2, h3');
			if (headings.length > 0) {
				var usedIds = {};
				Array.prototype.forEach.call(headings, function (heading, index) {
					var id = heading.getAttribute('id');
					if (!id) {
						id = heading.textContent.toLowerCase()
							.replace(/[^\w\u00c0-\uffff\s-]/g, '')
							.trim()
							.replace(/\s+/g, '-')
							.substring(0, 48);
						if (!id) id = 'section-' + index;
						if (usedIds[id]) id = id + '-' + index;
						usedIds[id] = true;
						heading.setAttribute('id', id);
					}
					var link = document.createElement('a');
					link.href = '#' + id;
					link.textContent = heading.textContent;
					if (heading.tagName.toLowerCase() === 'h3') {
						link.className = 'kt-toc__sub';
					}
					for (var i = 0; i < tocNavs.length; i++) {
						tocNavs[i].appendChild(link.cloneNode(true));
					}
				});
				Array.prototype.forEach.call(tocWraps, function (wrap) {
					wrap.removeAttribute('hidden');
				});

				// scrollspy
				var tocLinks = uniqueNodes('.kt-toc a, #kt-toc a, #kt-toc-mobile a');

				function scrollSpy() {
					var currentId = null;
					var offset = 120;
					Array.prototype.forEach.call(headings, function (heading) {
						var rect = heading.getBoundingClientRect();
						if (rect.top - offset <= 0) {
							currentId = heading.getAttribute('id');
						}
					});
					Array.prototype.forEach.call(tocLinks, function (link) {
						if (link.getAttribute('href') === '#' + currentId) {
							link.classList.add('is-active');
						} else {
							link.classList.remove('is-active');
						}
					});
				}
				window.addEventListener('scroll', scrollSpy, { passive: true });
				scrollSpy();
			}
		}

		/* ============ 6. Copy-link share button ============ */
		var copyButtons = document.querySelectorAll('.kt-copy-link');
		Array.prototype.forEach.call(copyButtons, function (btn) {
			btn.addEventListener('click', function () {
				var url = btn.getAttribute('data-url');
				function done() {
					btn.classList.add('is-copied');
					var icon = btn.querySelector('.material-symbols-outlined');
					if (icon) icon.textContent = 'check';
					setTimeout(function () {
						btn.classList.remove('is-copied');
						if (icon) icon.textContent = 'link';
					}, 2000);
				}
				if (navigator.clipboard && navigator.clipboard.writeText) {
					navigator.clipboard.writeText(url).then(done, done);
				} else {
					var tmp = document.createElement('input');
					tmp.value = url;
					document.body.appendChild(tmp);
					tmp.select();
					try { document.execCommand('copy'); } catch (e) { }
					document.body.removeChild(tmp);
					done();
				}
			});
		});

		/* ============ 6b. Share popup for social buttons ============ */
		var shareContainers = document.querySelectorAll('.kt-share-buttons');
		Array.prototype.forEach.call(shareContainers, function (container) {
			container.addEventListener('click', function (e) {
				var btn = e.target.closest('.kt-share-btn');
				if (!btn || btn.classList.contains('kt-copy-link')) return;
				var href = btn.getAttribute('href');
				if (!href || href === '#' || btn.getAttribute('data-popup') !== '1') return;
				e.preventDefault();
				var width = 600;
				var height = 400;
				var left = Math.round((window.innerWidth - width) / 2 + (window.screenX || window.screenLeft || 0));
				var top = Math.round((window.innerHeight - height) / 2 + (window.screenY || window.screenTop || 0));
				var features = 'width=' + width + ',height=' + height + ',top=' + top + ',left=' + left + ',scrollbars=yes,resizable=yes';
				window.open(href, 'ktShareWindow', features);
			});
		});

		/* ============ 7. Tools directory live filter ============ */
		var toolsGrid = document.getElementById('kt-tools-grid');
		if (toolsGrid) {
			var toolCards = toolsGrid.querySelectorAll('.kt-tool-card');
			var toolsSearch = document.getElementById('kt-tools-search');
			var toolsCats = document.getElementById('kt-tools-cats');
			var toolsCatSelect = document.getElementById('kt-tools-catselect');
			var toolsCount = document.querySelector('.kt-tools-gridhead__count');
			var toolsTitle = document.getElementById('kt-tools-gridtitle');
			var toolsEmpty = document.getElementById('kt-tools-noresults');
			var activeCategory = '';
			var activeQuery = '';
			var categoryNames = {};

			if (toolsCats) {
				Array.prototype.forEach.call(toolsCats.querySelectorAll('li'), function (li) {
					categoryNames[li.getAttribute('data-category')] = li.querySelector('span:last-child').textContent;
				});
			}

			function filterTools() {
				var visible = 0;
				Array.prototype.forEach.call(toolCards, function (card) {
					var title = card.getAttribute('data-title') || '';
					var desc = card.getAttribute('data-desc') || '';
					var cats = (card.getAttribute('data-categories') || '').split(' ');
					var matchCategory = !activeCategory || cats.indexOf(activeCategory) !== -1;
					var matchQuery = !activeQuery || title.indexOf(activeQuery) !== -1 || desc.indexOf(activeQuery) !== -1;
					if (matchCategory && matchQuery) {
						card.parentNode.style.display = '';
						visible++;
					} else {
						card.parentNode.style.display = 'none';
					}
				});
				if (toolsCount) {
					toolsCount.textContent = toolsCount.textContent.replace(/\d+/, String(visible));
				}
				if (toolsTitle) {
					var label = categoryNames[activeCategory] || categoryNames[''];
					if (label) toolsTitle.textContent = label;
				}
				if (toolsEmpty) {
					if (visible === 0 && toolCards.length > 0) {
						toolsEmpty.removeAttribute('hidden');
					} else {
						toolsEmpty.setAttribute('hidden', '');
					}
				}
			}

			on(toolsSearch, 'input', function () {
				activeQuery = toolsSearch.value.toLowerCase().trim();
				filterTools();
			});

			if (toolsCats) {
				Array.prototype.forEach.call(toolsCats.querySelectorAll('li'), function (li) {
					li.querySelector('button').addEventListener('click', function () {
						Array.prototype.forEach.call(toolsCats.querySelectorAll('li'), function (other) {
							other.classList.remove('is-active');
							other.querySelector('button').setAttribute('aria-pressed', 'false');
						});
						li.classList.add('is-active');
						li.querySelector('button').setAttribute('aria-pressed', 'true');
						activeCategory = li.getAttribute('data-category') || '';
						if (toolsCatSelect) toolsCatSelect.value = activeCategory;
						filterTools();
					});
				});
			}

			on(toolsCatSelect, 'change', function () {
				activeCategory = toolsCatSelect.value;
				if (toolsCats) {
					Array.prototype.forEach.call(toolsCats.querySelectorAll('li'), function (li) {
						if ((li.getAttribute('data-category') || '') === activeCategory) {
							li.classList.add('is-active');
							li.querySelector('button').setAttribute('aria-pressed', 'true');
						} else {
							li.classList.remove('is-active');
							li.querySelector('button').setAttribute('aria-pressed', 'false');
						}
					});
				}
				filterTools();
			});
		}

		/* ============ 8. News grid/list view toggle ============ */
		var cardGrid = document.getElementById('kt-card-grid');
		var viewGridBtn = document.getElementById('kt-view-grid');
		var viewListBtn = document.getElementById('kt-view-list');

		if (cardGrid && viewGridBtn && viewListBtn) {
			on(viewGridBtn, 'click', function () {
				cardGrid.classList.remove('is-list-view');
				viewGridBtn.classList.add('is-active');
				viewListBtn.classList.remove('is-active');
				viewGridBtn.setAttribute('aria-pressed', 'true');
				viewListBtn.setAttribute('aria-pressed', 'false');
			});
			on(viewListBtn, 'click', function () {
				cardGrid.classList.add('is-list-view');
				viewListBtn.classList.add('is-active');
				viewGridBtn.classList.remove('is-active');
				viewListBtn.setAttribute('aria-pressed', 'true');
				viewGridBtn.setAttribute('aria-pressed', 'false');
			});
		}

		/* ============ 9. AJAX load more articles ============ */
		var loadMoreBtn = document.getElementById('kt-load-more');
		var loadMoreStatus = document.getElementById('kt-load-more-status');

		if (loadMoreBtn && cardGrid && typeof ktData !== 'undefined') {
			on(loadMoreBtn, 'click', function () {
				loadMoreBtn.classList.add('is-loading');
				loadMoreBtn.disabled = true;
				loadMoreBtn.setAttribute('aria-busy', 'true');
				if (loadMoreStatus) loadMoreStatus.textContent = 'Loading more articles';

				var body = new URLSearchParams();
				body.append('action', 'kt_load_more');
				body.append('nonce', ktData.nonce);
				body.append('paged', loadMoreBtn.getAttribute('data-paged'));
				body.append('per_page', loadMoreBtn.getAttribute('data-per-page') || '');
				body.append('category', loadMoreBtn.getAttribute('data-category') || 0);
				body.append('tag', loadMoreBtn.getAttribute('data-tag') || '');
				body.append('search', loadMoreBtn.getAttribute('data-search') || '');

				fetch(ktData.ajaxUrl, {
					method: 'POST',
					headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
					body: body.toString()
				})
					.then(function (res) { return res.json(); })
					.then(function (json) {
						loadMoreBtn.classList.remove('is-loading');
						loadMoreBtn.disabled = false;
						loadMoreBtn.removeAttribute('aria-busy');
						if (json && json.success && json.data && json.data.html) {
							var temp = document.createElement('div');
							temp.innerHTML = json.data.html;
							while (temp.firstChild) {
								cardGrid.appendChild(temp.firstChild);
							}
							var nextPage = parseInt(loadMoreBtn.getAttribute('data-paged'), 10) + 1;
							loadMoreBtn.setAttribute('data-paged', String(nextPage));
							if (!json.data.has_more) {
								loadMoreBtn.parentNode.style.display = 'none';
							}
							if (loadMoreStatus) loadMoreStatus.textContent = 'More articles loaded';
						} else {
							loadMoreBtn.parentNode.style.display = 'none';
							if (loadMoreStatus) loadMoreStatus.textContent = 'No more articles found';
						}
					})
					.catch(function () {
						loadMoreBtn.classList.remove('is-loading');
						loadMoreBtn.disabled = false;
						loadMoreBtn.removeAttribute('aria-busy');
						if (loadMoreStatus) loadMoreStatus.textContent = 'Unable to load more articles. Please try again.';
					});
			});
		}
	});
})();
